
export type PlanarFacePOIPoiType = typeof PlanarFacePOIPoiType[keyof typeof PlanarFacePOIPoiType];


export const PlanarFacePOIPoiType = {
  PlanarFacePOI: 'PlanarFacePOI',
} as const;
